import { uploadFile, uploadImagesForPointClouds } from "api/fileManager";

const fileUploaderApiConfig = {
  uploadFile,
  uploadImagesForPointClouds
};

export default fileUploaderApiConfig;